import {
  ConversationData,
  dispatch,
  ErrorVariants,
  getWorkspaceId,
  showToast,
  useAppSelector,
  useUpdateConversationTagsMutation,
} from '@zonofi/zono-money-store';
import { useMemo } from 'react';

interface AssignTagPayload {
  conversation: ConversationData;
  updateConversations: (item: ConversationData) => void;
}

export const useAssignTags = ({
  conversation,
  updateConversations,
}: AssignTagPayload) => {
  const [updateTags] = useUpdateConversationTagsMutation();
  const workspaceId = useAppSelector(getWorkspaceId);

  // const assignedTags = useMemo(
  //   () => conversation.metadata.tags ?? [],
  //   [conversation]
  // );
  const assignedTags: string[] = [];
  const showSuccessMessage = (tags: string[]) => {
    let successMsg = '';
    if (assignedTags.length < tags.length) {
      successMsg = 'Tag added successfully';
    } else if (assignedTags.length > tags.length) {
      successMsg = 'Tag removed successfully';
    }
    if (successMsg.length !== 0) {
      dispatch(
        showToast({
          canDisplay: true,
          message: successMsg,
          responseStatus: 'success',
          type: ErrorVariants.SUCCESS,
        })
      );
    }
  };

  const onUpdateTags = (tags: string[]) => {
    updateTags({
      workspaceId,
      conversationId: conversation.conversationThreadId ?? '',
      tags,
    })
      .unwrap()
      .then((response) => {
        // Use the current conversation snapshot to avoid overwriting fields
        // when modal closes before mutation resolves.
        const updatedConversation: ConversationData = {
          ...conversation,
          metadata: {
            ...conversation.metadata,
            tags: response?.tags ?? tags,
          },
        };
        updateConversations(updatedConversation);
        showSuccessMessage(tags);
      });
  };

  const onRemoveTag = (tag: string) => {
    const tags = assignedTags.filter((x) => x !== tag);
    onUpdateTags(tags);
  };

  const onAssignTag = (tag: string) => {
    const tags = [...assignedTags];
    tags.push(tag);
    onUpdateTags(tags);
  };

  return { onRemoveTag, onAssignTag };
};
